// Theme initializer: sets CSS custom properties from environment variables
// Usage: import and call initializeTheme() before rendering the app

const ENV_TO_CSS_VAR_MAP = {
  REACT_APP_COLOR_PRIMARY: '--primary-color',
  REACT_APP_COLOR_PRIMARY_LIGHT: '--primary-light',
  REACT_APP_COLOR_PRIMARY_DARK: '--primary-dark',
  REACT_APP_COLOR_SECONDARY: '--secondary-color',
  REACT_APP_COLOR_SECONDARY_DARK: '--secondary-dark',
  REACT_APP_COLOR_ACCENT: '--accent-color',
  REACT_APP_COLOR_ACCENT_LIGHT: '--accent-light',
  REACT_APP_COLOR_SUCCESS: '--success-color',
  REACT_APP_COLOR_SUCCESS_LIGHT: '--success-light',
  REACT_APP_COLOR_SUCCESS_DARK: '--success-dark',
  REACT_APP_COLOR_DANGER: '--danger-color',
  REACT_APP_COLOR_DANGER_DARK: '--danger-dark',
  REACT_APP_COLOR_WARNING: '--warning-color',
  REACT_APP_COLOR_WARNING_DARK: '--warning-dark',
  REACT_APP_COLOR_BORDER: '--border-color',
  REACT_APP_COLOR_HOVER: '--hover-color',
  REACT_APP_COLOR_TEXT: '--text-color',
  REACT_APP_COLOR_WHITE: '--white',
  REACT_APP_COLOR_GRAY_50: '--gray-50',
  REACT_APP_COLOR_GRAY_100: '--gray-100',
  REACT_APP_COLOR_GRAY_200: '--gray-200',
  REACT_APP_COLOR_GRAY_300: '--gray-300',
  REACT_APP_COLOR_GRAY_400: '--gray-400',
  REACT_APP_COLOR_GRAY_500: '--gray-500',
  REACT_APP_COLOR_GRAY_600: '--gray-600',
  REACT_APP_COLOR_GRAY_700: '--gray-700',
  REACT_APP_COLOR_GRAY_800: '--gray-800',
  REACT_APP_COLOR_GRAY_900: '--gray-900',
  // Public site theming
  REACT_APP_COLOR_PUBLIC_BG_START: '--public-bg-start',
  REACT_APP_COLOR_PUBLIC_BG_MID: '--public-bg-mid',
  REACT_APP_COLOR_PUBLIC_BG_END: '--public-bg-end',
  REACT_APP_COLOR_PUBLIC_HEADER_START: '--public-header-start',
  REACT_APP_COLOR_PUBLIC_HEADER_END: '--public-header-end',
  REACT_APP_COLOR_PUBLIC_PRIMARY: '--public-primary',
  REACT_APP_COLOR_PUBLIC_ACCENT: '--public-accent',
  REACT_APP_COLOR_PUBLIC_BORDER: '--public-border',
  REACT_APP_COLOR_PUBLIC_ORANGE_START: '--public-orange-start',
  REACT_APP_COLOR_PUBLIC_ORANGE_END: '--public-orange-end',
};

export function initializeTheme() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;

  const normalizeColor = (raw) => {
    if (!raw) return raw;
    const value = String(raw).trim();
    if (/^[0-9a-fA-F]{3}$/.test(value) || /^[0-9a-fA-F]{6}$/.test(value)) {
      return `#${value}`;
    }
    return value;
  };

  Object.entries(ENV_TO_CSS_VAR_MAP).forEach(([envKey, cssVar]) => {
    const value = normalizeColor(process.env[envKey]);
    if (value && typeof value === 'string' && value.trim() !== '') {
      try {
        root.style.setProperty(cssVar, value.trim());
      } catch (_err) {
        // Ignore invalid values; keep defaults
      }
    }
  });
}

export default initializeTheme;


